import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * items = [{ label, to? }]
 * Automatically emits BreadcrumbList JSON-LD.
 */
export default function Breadcrumbs({ items = [] }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "https://kinflexhomehealthcare.com";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: it.label,
      item: it.to ? `${origin}${it.to}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-slate-500 flex-wrap" data-testid="breadcrumbs">
        <Link to="/" className="inline-flex items-center gap-1 hover:text-[#0A84FF]">
          <Home className="h-3 w-3" /> Home
        </Link>
        {items.map((it, i) => (
          <React.Fragment key={i}>
            <ChevronRight className="h-3 w-3 text-slate-400" />
            {it.to && i !== items.length - 1 ? (
              <Link to={it.to} className="hover:text-[#0A84FF]">{it.label}</Link>
            ) : (
              <span className="text-slate-700 font-medium">{it.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </>
  );
}
